import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
export const Perk = ({ img, perkTitle, perkDescription }) => {
    return (React.createElement(Stack, { sx: { mb: 2 } },
        React.createElement(Box, { sx: {
                p: 1,
                mb: 2,
                width: '48px',
                height: '48px',
                display: 'flex',
                borderRadius: '50%',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'white',
            } }, img),
        React.createElement(Typography, { color: "white", fontSize: "0.9rem", fontWeight: 600 }, perkTitle),
        React.createElement(Typography, { fontWeight: 500, fontSize: "0.875rem", sx: { color: (theme) => theme.palette.grey[200] } }, perkDescription)));
};
